/**
 * Legacy api v1 client.
 * DEPRECATION WARNING: avoid using this instance for new requests
 * @deprecated
 */
import axios, { AxiosResponse } from 'axios';
import applyCsrfInterceptor from '@webapp-next/lib/request/utils/apply-csrf-interceptor';
import { DeputyHttpClientOptions } from '@/lib/types/request/deputy';
import querystring from 'querystring';
const baseUrl = '/api/v1';

const localAxios = axios.create({
  baseURL: baseUrl,
});

applyCsrfInterceptor(localAxios);

function http<Response>({
  url,
  headers,
  method,
  body,
  query,
  signal,
}: DeputyHttpClientOptions): Promise<AxiosResponse<Response> | Response> {
  // query
  if (typeof query === 'object' && Object.keys(query).length > 0) {
    url += `?${querystring.stringify(query)}`;
  }
  if (typeof query === 'string') {
    url += `?${query}`;
  }

  let includeHeaders = false;

  if (body && body.hasOwnProperty('exposeMeta')) {
    includeHeaders = body.exposeMeta || false;
    delete body.exposeMeta; // delete this body parameter
  }

  return localAxios({
    method,
    url,
    headers,
    data: body,
    signal,
  }).then(res => {
    const { data, status } = res;

    if (status.toString().match(/^2/)) {
      if (includeHeaders) {
        return res;
      }
      return data as Response;
    }
    throw res;
  });
}

const _testUrl = (url: string): void => {
  if (!url) {
    throw new Error('url is required');
  }
};

// eslint-disable-next-line valid-jsdoc
/**
 * Legacy api v1 client.
 * DEPRECATION WARNING: avoid using this instance for new requests
 * @deprecated
 */
function get<Response>(
  data: DeputyHttpClientOptions | string
): Promise<AxiosResponse<Response> | Response> {
  let url;
  let query;
  let signal;

  if (typeof data === 'string') {
    url = data;
  } else {
    url = data.url;
    query = data.query;
    signal = data.signal;
  }

  _testUrl(url);

  return http({
    method: 'GET',
    url,
    query,
    signal,
  });
}

// eslint-disable-next-line valid-jsdoc
/**
 * Legacy api v1 client.
 * DEPRECATION WARNING: avoid using this instance for new requests
 * @deprecated
 */
function put<Response>({
  url,
  headers,
  body,
  query,
  signal,
}: DeputyHttpClientOptions): Promise<AxiosResponse<Response> | Response> {
  _testUrl(url);
  return http({ method: 'PUT', url, headers, body, query, signal });
}

// eslint-disable-next-line valid-jsdoc
/**
 * Legacy api v1 client.
 * DEPRECATION WARNING: avoid using this instance for new requests
 * @deprecated
 */
function post<Response>({
  url,
  headers,
  body,
  query,
  signal,
}: DeputyHttpClientOptions): Promise<AxiosResponse<Response> | Response> {
  _testUrl(url);
  return http({ method: 'POST', url, headers, body, query, signal });
}

// eslint-disable-next-line valid-jsdoc
/**
 * Legacy api v1 client.
 * DEPRECATION WARNING: avoid using this instance for new requests
 * @deprecated
 */
function destroy<Response>({
  url,
  headers,
  query,
  signal,
}: DeputyHttpClientOptions): Promise<AxiosResponse<Response> | Response> {
  _testUrl(url);
  return http({ method: 'DELETE', url, headers, query, signal });
}

export { get, put, post, destroy };
export default { get, put, post, destroy };
